import { Roles } from "src/utils/Constants"
import { filterNavSection } from "./helpers"
import { ITEM_VISIBILITY_RULES, SUB_ITEM_VISIBILITY_RULES } from "./moduleRules"
import { getAdministradorSections } from "./roles/administrador"
import { getSupervisorSections } from "./roles/supervisor"
import { getParkeySections } from "./roles/parkey"
import { getSuperAdminSections } from "./roles/superAdministrador"
import { getEmpresaSections } from "./roles/empresa"
import { getDirectivaSections } from "./roles/directiva"
import { getPuntoVentaSections } from "./roles/puntoVenta"

const SECTION_BUILDERS = {
  [Roles.admin]: getAdministradorSections,
  [Roles.supervisor]: getSupervisorSections,
  [Roles.parkey]: getParkeySections,
  [Roles.superadmin]: getSuperAdminSections,
  [Roles.company]: getEmpresaSections,
  [Roles.directiva]: getDirectivaSections,
  [Roles.puntoVenta]: getPuntoVentaSections,
}

export const getNavSections = (rol, { t, modulos, user } = {}) => {
  const builder = SECTION_BUILDERS[rol]
  if (!builder) return []

  const sections = builder(t)
  const ctx = {
    rol,
    modulos,
    user,
    applySubItemRules: rol === Roles.admin,
    rules: { ITEM_VISIBILITY_RULES, SUB_ITEM_VISIBILITY_RULES },
  }

  return sections
    .map(section => filterNavSection(section, ctx))
    .filter(section => section.items.length > 0)
}

export { canSwitchComplex, needsComplexModules } from "./policies"
export {
  getActiveNavItemId,
  hasActiveChild,
  isHrefActive,
  isNavItemActive,
} from "./helpers"
